import SvgIcon from "@mui/material/SvgIcon";
import { ReactSVG } from "react-svg";
import arrowBack from "../assets/img/arrow-back.svg";
import inspectionIcon from "../assets/img/icons/inspectionNo.png";
import requestIcon from "../assets/img/icons/requestNo.png";
import Outdoors from "../assets/img/outdoors.png";
import Satellite from "../assets/img/satellite.png";
import Light from "../assets/img/light.png";
import Dark from "../assets/img/dark.png";
import Streets from "../assets/img/streets.png";
import Button from "@mui/material/Button";
import Low from "../assets/img/icons/low.png";
import Medium from "../assets/img/icons/medium.png";
import High from "../assets/img/icons/high.png";
import Status from "../assets/img/icons/status.png";
import Severity from "../assets/img/icons/severity.png";
import IdentificationFlags from "../assets/img/icons/identification-flags.png";
import PoleFlags from "../assets/img/icons/pole-flags.png";
import SecurityNotes from "../assets/img/icons/security-notes.png";
import GeneralNotes from "../assets/img/icons/general-notes.png";
import { Chip } from "@mui/material";
import { Tooltip, tooltipClasses } from "@mui/material";

import { alpha, styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

import OutlinedInput from "@mui/material/OutlinedInput";

export const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} arrow />
))(({ theme }) => ({
  zIndex: 1,
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "black",
    fontSize: "14px",
    fontWeight: "bold",
    borderRadius: "5px",
    padding: "6px 12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
    border: "0.5px solid black",
    minWidth: "100px",
    minHeight: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "white",
  },
}));

export const CustomSelect = styled(OutlinedInput)(({ theme }) => ({
  borderRadius: "10px",
  height: "38px",
  minHeight: "38px",
  fontFamily: "'Space Grotesk', sans-serif",
  fontSize: "12px",
  "& .MuiOutlinedInput-input": {
    padding: "0 12px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "10px",
    borderColor: "#ced4da",
    borderWidth: "1px",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ced4da",
    borderWidth: "1px",
  },
  "&.MuiOutlinedInput-root": {
    boxShadow: "none !important",
  },
  "&.Mui-focused": {
    borderColor: "#ced4da",
    boxShadow: "none",
    backgroundColor: "transparent",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ced4da",
  },
  "&:hover": {
    backgroundColor: "rgba(204, 204, 204, 0.3)",
    boxShadow: "0px 0px 8px rgba(195, 194, 194, 0.2)",
  },
}));

export const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#27c59b",
    "&:hover": {
      backgroundColor: alpha("#27c59b", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#27c59b",
  },
}));

export const Months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const STAGE_API_URL = "https://stage.detect-inspections.com";
export const PROD_API_URL = "https://service.detect-inspections.com";
export const TEST_API_URL = "http://34.71.230.126";

export const chartData1 = {
  datasets: [
    {
      data: [1, 2, 3],
      backgroundColor: [
        "rgba(221, 44, 0, 0.8)",
        "rgba(249, 168, 37, 0.8)",
        "rgba(102, 187, 106, 0.8)",
      ],
      borderColor: [
        "rgba(221, 44, 0, 1)",
        "rgba(249, 168, 37, 1)",
        "rgba(102, 187, 106, 1)",
      ],
      borderWidth: 1,
    },
  ],
};

export const StatusConstants = {
  1: "PENDING",
  2: "PHOTOS UPLOADED",
  3: "ANNOTATED",
  4: "REVIEWED",
  5: "REJECTED",
  6: "APPROVED",
};

export const getStatusStyles = (val) => {
  switch (val) {
    case 1:
      return {
        backgroundColor: "rgba(204, 204, 204, 0.8)",
        color: "#000000",
        fontSize: "13.5px",
        fontWeight: 500,
      };
    case 2:
      return {
        backgroundColor: "rgba(159, 197, 248, 0.5)",
        color: "#0a4273",
        fontSize: "13.5px",
        fontWeight: 500,
      };
    case 3:
      return {
        backgroundColor: "#fee2d3",
        color: "#ff8039",
        fontSize: "13.5px",
        fontWeight: 500,
      };
    case 4:
      return {
        backgroundColor: "rgba(188, 119, 66, 0.45)",
        color: "#633900",
        fontSize: "13.5px",
        fontWeight: 500,
      };
    case 5:
      return {
        backgroundColor: "#ffd7d7",
        color: "#dd2c00",
        fontSize: "13.5px",
        fontWeight: 500,
      };
    case 6:
      return {
        backgroundColor: "#ddffcd",
        color: "#007f00",
        fontSize: "13.5px",
        fontWeight: 500,
      };
    default:
      return {}; // Default styles
  }
};

export const UploadStatusConstants = {
  0: "FAILED",
  1: "SUCCESSFUL",
};

export const getUploadStatusStyles = (val) => {
  switch (val) {
    case 0:
      return {
        backgroundColor: "#ffd7d7",
        color: "#dd2c00",
      };
    case 1:
      return {
        backgroundColor: "#ddffcd",
        color: "#007f00",
      };
    default:
      return {};
  }
};

export const UPLOAD_BATCH_SIZE = 10;

export const ThreeDotsIcon = (props) => {
  return (
    <SvgIcon {...props} width="50" height="20" viewBox="0 0 50 20">
      <circle cx="10" cy="10" r="4" />
      <circle cx="25" cy="10" r="4" />
      <circle cx="40" cy="10" r="4" />
    </SvgIcon>
  );
};

export const PrevArrow = ({ onClick, isDisabled }) => {
  return (
    <div
      className="back-carousal"
      onClick={onClick}
      style={{ display: isDisabled ? "none" : "" }}
    >
      <ReactSVG src={arrowBack} />
    </div>
  );
};

export const NextArrow = ({ onClick, isDisabled }) => {
  return (
    <div
      className="front-carousal"
      onClick={onClick}
      style={{ display: isDisabled ? "none" : "" }}
    >
      <ReactSVG src={arrowBack} />
    </div>
  );
};

export const statusOptions = [
  {
    label: "PENDING",
    backgroundColor: "rgba(204, 204, 204, 0.8)",
    color: "#000000",
    value: 1,
  },
  {
    label: "PHOTOS UPLOADED",
    backgroundColor: "rgba(159, 197, 248, 0.5)",
    color: "#0a4273",
    value: 2,
  },
  {
    label: "ANNOTATED",
    backgroundColor: "#fee2d3",
    color: "#ff8039",
    value: 3,
  },
  {
    label: "REVIEWED",
    backgroundColor: "rgba(188, 119, 66, 0.45)",
    color: "#633900",
    value: 4,
  },
  {
    label: "REJECTED",
    backgroundColor: "#ffd7d7",
    color: "#dd2c00",
    value: 5,
  },
  {
    label: "APPROVED",
    backgroundColor: "#ddffcd",
    color: "#007f00",
    value: 6,
  },
];

export const DistributionStatusConstants = {
  pending: 1,
  photos_uploaded: 2,
  assigned: 3,
  analyzed: 4,
  accepted: 5,
  reshoot: 6,
  overviewed: 7,
  not_applicable: 8,
};

export const distributionStatuses = {
  1: {
    label: "Pending",
    key: "pending",
    color: "#808080",
    value: 1,
    backgroundColor: "rgba(204, 204, 204, 0.8)",
  },
  2: {
    label: "Photos Uploaded",
    key: "photos_uploaded",
    color: "#0a4273",
    value: 2,
    backgroundColor: "rgba(159, 197, 248, 0.5)",
  },
  3: {
    label: "Assigned",
    key: "assigned",
    color: "#ff8039",
    value: 3,
    backgroundColor: "#fee2d3",
  },
  4: {
    label: "Analyzed",
    key: "analyzed",
    color: "#8A2BE2",
    value: 4,
    backgroundColor: "#f1e4ff",
  },
  5: {
    label: "Accepted",
    key: "accepted",
    color: "#007f00",
    value: 5,
    backgroundColor: "#ddffcd",
  },
  6: {
    label: "Reshoot",
    key: "reshoot",
    color: "#dd2c00",
    value: 6,
    backgroundColor: "#ffd7d7",
  },
  7: {
    label: "Overviewed",
    key: "overviewed",
    color: "#633900",
    value: 7,
    backgroundColor: "rgba(188, 119, 66, 0.45)",
  },
  8: {
    label: "Not Applicable",
    key: "not_applicable",
    color: "#00B8D9",
    value: 8,
    backgroundColor: "rgba(0, 184, 217, 0.15)",
  },
};

export const distributionButtonsConfig = [
  {
    condition: (status, role) =>
      status === DistributionStatusConstants.assigned && role === "Analyst",
    label: "Mark Analyzed",
    nextStatus: DistributionStatusConstants.analyzed,
    optionLabel: "Analyzed",
  },
];

export const roleOptions = [
  { label: "Admin", value: "admin" },
  { label: "Operation", value: "operation" },
  { label: "Viewer", value: "viewer" },
];

export const orgOptions = [
  { label: "Enl", value: "enl" },
  { label: "Detect", value: "detect" },
  { label: "Nspi", value: "nspi" },
];

export const defectOptions = [
  { label: "High", icon: High, rotation: 180, value: "high" },
  { label: "Medium", icon: Medium, rotation: 270, value: "medium" },
  { label: "Low", icon: Low, rotation: 360, value: "low" },
];

export const components = ["Cross Arm", "Guy", "Hardware", "Insulator", "Pole"];

export const inspectionsSortOptions = [
  { label: "Oldest", icon: requestIcon, value: "created_at" },
  { label: "Newest", icon: requestIcon, value: "-created_at" },
  {
    label: "Line Number (A-Z)",
    icon: inspectionIcon,
    value: "powerline__line_number",
  },
  {
    label: "Line Number (Z-A)",
    icon: inspectionIcon,
    value: "-powerline__line_number",
  },
];

export const requestTypes = [
  { label: "All", value: "" },
  { label: "Transmission", value: 1 },
  {
    label: "Distribution",
    value: 2,
  },
];

export const infoTabOptions = {
  1: "DEFAULT",
  2: "TRANSMISSION",
  3: "DISTRIBUTION",
  4: "COMPONENT",
};

export const severityOptions = [
  { id: 1, severity: "Good", color: "#848484" },
  { id: 2, severity: "Low", color: "#66bb6a" },
  { id: 3, severity: "Medium", color: "#f9a825" },
  { id: 4, severity: "High", color: "#dd2c00" },
];

export const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#ffffff"), // Text color
  backgroundColor: "#ffffff", // Background color
  borderRadius: "16px", // Rounded corners
  border: "2px solid #333", // Dark grey border
  padding: "4px 10px",
  fontSize: "11.5px",
  "&:hover": {
    backgroundColor: "#e0e0e0", // Slightly darker shade on hover
  },
  width: "141px",
}));

export const annotationSeverityOptions = [
  {
    id: 1,
    severity: "Good",
    color: "rgb(202, 202, 202)",
    fill: "rgb(202, 202, 202, 0.1)",
  },
  {
    id: 2,
    severity: "Low",
    color: "rgb(102, 187, 106)",
    fill: "rgb(102, 187, 106, 0.1)",
  },
  {
    id: 3,
    severity: "Medium",
    color: "rgb(249, 168, 37)",
    fill: "rgb(249, 168, 37, 0.1)",
  },
  {
    id: 4,
    severity: "High",
    color: "rgb(221, 44, 0)",
    fill: "rgb(221, 44, 0, 0.1)",
  },
];

export const mapStyles = {
  light: {
    mapUrl: "mapbox://styles/mapbox/light-v11",
    image: Light,
  },
  dark: {
    mapUrl: "mapbox://styles/mapbox/dark-v11",
    image: Dark,
  },
  streets: {
    mapUrl: "mapbox://styles/mapbox/streets-v12",
    image: Streets,
  },
  outdoor: {
    mapUrl: "mapbox://styles/mapbox/outdoors-v12",
    image: Outdoors,
  },
  satellite: {
    mapUrl: "mapbox://styles/mapbox/satellite-v9",
    image: Satellite,
  },
};

export const mapDataStyles = {
  severity: {
    image: Severity,
  },
  status: {
    image: Status,
  },
};

export const getSeverityTag = (severity) => {
  let color = "";
  let label = "";
  switch (severity) {
    case 2:
      color = "rgb(102, 187, 106)";
      label = "Low";
      break;
    case 3:
      color = "rgb(249, 168, 37)";
      label = "Medium";
      break;
    case 4:
      color = "rgb(221, 44, 0)";
      label = "High";
      break;
    default:
      color = "rgb(202, 202, 202)";
      label = "Good";
  }
  return (
    <Chip
      label={label}
      sx={{
        backgroundColor: color,
        color: "white",
        fontWeight: "semi-bold",
        fontSize: "13px",
        marginRight: "200px",
        width: "72px",
      }}
    />
  );
};

export const iconMeta = [
  {
    src: IdentificationFlags,
    key: "identification_flags",
  },
  { src: SecurityNotes, key: "safety_notes" },
  { src: PoleFlags, key: "pole_flag" },
  { src: GeneralNotes, key: "general_notes" },
];

export const workBlockColors = [
  "#0A4273",
  "#FF8039",
  "#8A2BE2",
  "#007F00",
  "#633900",
  "#00B8D9",
  "#E91E63",
  "#9C27B0",
  "#673AB7",
  "#3F51B5",
  "#2196F3",
  "#03A9F4",
  "#02BCD4",
  "#009688",
  "#4CAF50",
  "#8BC34A",
  "#CDDC39",
  "#FFEB3B",
  "#FFC107",
  "#FF9800",
  "#FFA07A",
  "#795548",
  "#FFC107",
  "#FF00FF",
  "#7FFF00",
  "#00FF00",
  "#1A237E",
  "#880E4F",
  "#004D40",
  "#015E93"
]

export const mapboxDrawStyles = [
  // ACTIVE (being drawn)
  // line stroke
  {
    id: "gl-draw-line",
    type: "line",
    filter: ["all", ["==", "$type", "LineString"]],
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "#00b588",
      "line-dasharray": [0.2, 2],
      "line-width": 2
    }
  },
  // polygon fill
  {
    id: "gl-draw-polygon-fill",
    type: "fill",
    filter: ["all", ["==", "$type", "Polygon"]],
    paint: {
      "fill-color": "#00b588",
      "fill-outline-color": "#00b588",
      "fill-opacity": 0.1
    }
  },
  // polygon mid points
  {
    id: "gl-draw-polygon-midpoint",
    type: "circle",
    filter: ["all",
      ["==", "$type", "Point"],
      ["==", "meta", "midpoint"]
    ],
    paint: {
      "circle-radius": 3,
      "circle-color": "#00b588"
    }
  },
  // polygon outline stroke
  {
    id: "gl-draw-polygon-stroke-active",
    type: "line",
    filter: ["all", ["==", "$type", "Polygon"]],
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "#00b588",
      "line-dasharray": [0.2, 2],
      "line-width": 2
    }
  },
  // vertex point halos
  {
    id: "gl-draw-polygon-and-line-vertex-halo-active",
    type: "circle",
    filter: ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"]],
    paint: {
      "circle-radius": 5,
      "circle-color": "#00b588"
    }
  },
  // vertex points
  {
    id: "gl-draw-polygon-and-line-vertex-active",
    type: "circle",
    filter: ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"]],
    paint: {
      "circle-radius": 3,
      "circle-color": "#00b588"
    }
  }
];